import { getJustIdentitiesValues } from './identities';
/**
 * Subscribers / observers
 */
let _subscribers = [];
export const runSubscribers = (data) => {
    if (_subscribers.length) {
        let justValues = null;
        _subscribers.forEach((s) => {
            if (!s.rich && !justValues) {
                justValues = getJustIdentitiesValues(data.identities);
            }
            s.callback(Object.assign(Object.assign({}, data), { identities: s.rich ? data.identities : justValues }));
        });
    }
};
/**
 * Subscribe to storage changes.
 * Returns function for unsubscribing.
 */
export const subscribe = (callback, rich = false) => {
    _subscribers.push({ callback, rich });
    return () => {
        _subscribers = _subscribers
            .map((s) => {
            return s.callback === callback ? null : s;
        })
            .filter(Boolean);
    };
};
